import React, { useState } from 'react';
import axios from 'axios';

const FileUploader = ({ name, onUpload, label }) => {
  const [preview, setPreview] = useState(null);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProgress(0);
    setError(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post(
        '/upload',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          }
        }
      );

      const fileUrl = response.data.file_url;
      setPreview({ type: file.type, url: fileUrl });
      onUpload(name, fileUrl);

    } catch (err) {
      console.error('Upload failed:', err);
      setError('Upload failed. Please try again.');
    }
  };

  const renderPreview = () => {
    if (!preview) return null;
    const { type, url } = preview;

    if (type.startsWith('image/')) {
      return <img src={url} alt="uploaded" className="mt-2" style={{ width: '100px' }} />;
    }
    if (type === 'application/pdf') {
      return (
        <div className="mt-2">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <i className="bi bi-file-earmark-pdf-fill" style={{ fontSize: '2rem', color: 'red' }} />
          </a>
        </div>
      );
    }
    return (
      <div className="mt-2">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <i className="bi bi-file-earmark-text-fill" style={{ fontSize: '2rem', color: 'gray' }} />
        </a>
      </div>
    );
  };

  return (
    <div className={label ? "mb-3" : ""}>
      {label && <label className="form-label">{name}</label>}

      <input
        type="file"
        className="form-control form-control-sm"
        accept=".png,.jpg,.jpeg,.pdf,.txt"
        onChange={handleFileChange}
      />

      {progress > 0 && progress < 100 && (
        <div className="progress mt-2">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {progress}%
          </div>
        </div>
      )}

      {error && <div className="text-danger mt-2">{error}</div>}

      {renderPreview()}
    </div>
  );
};

export default FileUploader;
